import { useFormContext } from 'react-hook-form';
import { FILTER_SECTIONS, Filter } from '@anytag/shared-molecules';
import {
  AgeField,
  FollowerField,
  PostPriceField,
  EngagementRateField,
  InfluencerStatusField,
  RegionAndProvinceField,
  InfluencerCategoryField,
  TalentAgencyPartnerField
} from '../../shared';
import { AdvancedFilterDefaultProps } from '../../schemaTypes';
import { defaultTwitterInfluencersFormValues, TwitterInfluencersFilterFormValues } from '../schemaTypes';

export const AdvancedFilter = ({ count, onSubmit }: AdvancedFilterDefaultProps) => {
  const { reset, getValues } = useFormContext<TwitterInfluencersFilterFormValues>();

  const values = getValues();

  const handleClear = () => {
    reset({
      ...defaultTwitterInfluencersFormValues,
      // Basic filter
      keyword: values.keyword,
      genders: values.genders,
      countryIds: values.countryIds
    });
  };

  return (
    <Filter.MoreFilterPopover
      count={count}
      onClear={handleClear}
      onSubmit={onSubmit}
      items={[
        {
          value: FILTER_SECTIONS.InfluencerAttributes,
          title: FILTER_SECTIONS.InfluencerAttributes,
          node: (
            <>
              <AgeField />
              <InfluencerStatusField />
              <TalentAgencyPartnerField />
              <InfluencerCategoryField />
              <RegionAndProvinceField />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.PerformanceFilter,
          title: FILTER_SECTIONS.PerformanceFilter,
          node: (
            <>
              <FollowerField />
              <EngagementRateField />
              <PostPriceField />
            </>
          )
        }
      ]}
    />
  );
};
